<template lang="pug">
#Register
  .container.register
    center
      img(src="../../../public/Now-Logo.png" style="width: 150px")
    br

    b-card(no-body='')
      .card-header.text-center
        h4  {{ `Registro - ${registrationSuccess ? 'Completado' : `Paso ${step} de 3`}` }}

      b-progress(:value='progress' :max='100' variant="success" animated height='5px')

      .card-body
        // Paso 1: Datos de la cuenta
        div(v-if='step === 1')
          form(@submit.prevent='nextStep')
            .box-form
              .material-icons.icon account_box
              .group
                b-form-group(label-for="input-name")
                  .title
                    | Nombre
                    span.text-danger.ml-1(v-if="!form.name") *
                    span.text-success.ml-1(v-else)
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-form-input.input(
                    id="input-name"
                    type="text"
                    placeholder="Ingresa tu nombre"
                    v-model="form.name"
                    required
                    style=""
                    @input="value => form.name = cleanInput(value)"
                  )
            hr
            .box-form
              .material-icons.icon account_box
              .group
                b-form-group(label-for="input-lastName")
                  .title Apellido
                    span.text-success.ml-1(v-if="form.lastName")
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-form-input.input(
                    id="input-lastName"
                    type="text"
                    placeholder="Ingresa tu apellido"
                    v-model="form.lastName"
                    @input="value => form.lastName = cleanInput(value)"
                  )
            hr
            .box-form
              .material-icons.icon email
              .group
                b-form-group(label-for="input-email")
                  .title
                    | Correo
                    span.text-danger.ml-1(v-if="isEmailAvailable !== true") *
                    span.text-success.ml-1(v-else)
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-form-input.input(
                    id="input-email"
                    type="email"
                    placeholder="Ingresa tu correo"
                    v-model="form.email"
                    required
                    @blur="handleCheckEmail"
                    @input="debouncedCheckEmail"
                  )
                  b-form-text(v-if="isEmailAvailable === false && !checkingEmail")
                    .text-danger.pl-2 Este correo ya está registrado

                  b-form-text.d-flex(v-else-if="isEmailAvailable === true && !checkingEmail")
                    .text(style="color: #34C38F") Este correo está disponible
                    //- i.material-icons.text-success(style="font-size: 1rem;") check_outline

                  b-spinner(v-if="checkingEmail" variant="secondary" small style="margin-left: 0.5rem;")
            hr
            .box-form
              .material-icons.icon phone
              .group
                b-form-group(label-for="input-phone" style="color:white")
                  .title
                    | Teléfono
                    span.text-danger.ml-1(v-if="!form.phone") *
                    span.text-success.ml-1(v-else)
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-input-group
                    b-input-group-prepend
                      .input-group-text(style="background-color: transparent; border: none;")
                        | +56
                    b-form-input.input#input-phone(
                      type="tel"
                      v-model="form.phone"
                      placeholder="9 1234 5678"
                      required
                      :formatter="phoneNumberFormatter"
                    )
            hr
            .box-form
              .material-icons.icon store
              .group
                b-form-group(label-for="input-store-name" style="color:white")
                  .title
                    | Nombre de la Tienda
                    span.text-danger.ml-1(v-if="!form.storeName") *
                    span.text-success.ml-1(v-else)
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-form-input.input(
                    id="input-store-name"
                    type="text"
                  placeholder="Ingresa el nombre de la Tienda"
                    v-model="form.storeName"
                    required
                    @input="value => form.storeName = cleanInput(value)"
                  )
            hr
            .box-form
              .material-icons.icon store
              .group
                b-form-group(label-for="input-instagram")
                  .title
                    | Instagram de la Tienda
                    span.text-danger.ml-1(v-if="!form.storeInstagram") *
                    span.text-success.ml-1(v-else)
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-form-input.input(
                    id="input-instagram"
                    type="text"
                    placeholder="Ingresa el instagram de tu tienda"
                    v-model="form.storeInstagram"
                    required
                    @input="value => form.storeInstagram = handleInstagramInput(value)"
                  )
            hr
            .box-form
              .material-icons.icon(style="color: #3EF7DE") place
              .group
                b-form-group(label-for="input-region")
                  .title
                    | Región
                    span.text-danger.ml-1(v-if="!form.region") *
                    span.text-success.ml-1(v-else)
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-form-input.input(
                    id="input-region"
                    type="text"
                    placeholder="Ingresa tu región"
                    v-model="form.region"
                    required
                    :disabled="true"
                    )
            hr
            .box-form
              .material-icons.icon place
              .group
                b-form-group(label-for="input-commune")
                  .title
                    | Comuna
                    span.text-danger.ml-1(v-if="!form.commune") *
                    span.text-success.ml-1(v-else)
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-form-select(
                    id="input-commune"
                    v-model="form.commune"
                    :options="communeOptions"
                    required
                  )
            hr
            .box-form
              .material-icons.icon place
              .group
                b-form-group(label-for="input-street-name")
                  .title
                    | Calle
                    span.text-danger.ml-1(v-if="!form.streetName") *
                    span.text-success.ml-1(v-else)
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-form-input.input(
                    id="input-street-name"
                    type="text"
                    placeholder="Ingresa tu Calle"
                    v-model="form.streetName"
                    required
                    @input="value => form.streetName = cleanInput(value)"
                  )
            hr
            .box-form
              .material-icons.icon place
              .group
                b-form-group(label-for="input-street-number")
                  .title
                    | Número de calle
                    span.text-danger.ml-1(v-if="!form.streetNumber") *
                    span.text-success.ml-1(v-else)
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-form-input.input(
                    id="input-street-number"
                    type="text"
                    placeholder="Ingresa tu número de calle"
                    v-model="form.streetNumber"
                    required
                    @input="value => form.streetNumber = cleanInput(value)"
                  )
            hr
            .box-form
              .material-icons.icon place
              .group
                b-form-group(label-for="input-apartment")
                  .title
                    | Detalle: bloque / depto / oficina
                    span.text-success.ml-1(v-if="form.apartment")
                      i.material-icons(style="font-size: 1rem;") check_outline
                  b-form-input.input(
                    id="input-apartment"
                    type="text"
                    placeholder="Ej: depto 301"
                    v-model="form.apartment"
                    required
                    @input="value => form.apartment = cleanInput(value)"
                  )
            hr

            .divider.d-flex.justify-content-end.mt-
              b-button(
                type='submit'
                :variant="isFormValid ? 'secondary' : 'primary'"
                :disabled="!isFormValid || loading"
              )
                span(v-if="!loading") Siguiente
                b-spinner(v-else small variant="light" style="margin-right: 8px;")
                span(v-if="loading") Cargando...

            center.divider.back-to-login.mt-4.mb-4.pb-2
              router-link.register(:to="{ name: 'Login' }") ¿Ya tienes cuenta? Inicia sesión aquí

        // Paso 2: Verificación por código
        div(v-if='step === 2')
          form(@submit.prevent='nextStep')
            .text-center.my-3.pb-3.text-primary
              p.mb-0 {{ 'Hemos enviado un código de 6 dígitos a ' }}
              strong {{ maskEmail(this.form.email) }}
            //- .title.ml-0.pl-4 Código de verificación
            b-form-group.pl-4.pr-4(label-for='code-input')
              .input-group
                b-form-input#code-input.form-control.text-center(
                  v-model.number='form.code'
                  type='text'
                  maxlength='6'
                  placeholder='Ingresa tu código'
                  oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                  style='color:black; font-size: 1.5rem; padding-left: 4rem;'
                )
                .input-group-append
                  b-button(variant='primary' @click='pasteCodeFromClipboard') Pegar
                    //- .material-icons.icon(style="padding: 0; margin: 0;") content_paste

            .text-center
              span.text-danger(v-if="errorMessage") {{ errorMessage }}

            .text-center.my-3.text-primary.px-4.pb-4
              small.mt-1.d-block
                |
                |
                a(href="#" @click.prevent="showHelp = !showHelp") ¿No recibiste el código?
              transition(name="fade")
                div(v-show="showHelp" style="font-size: 0.9rem;")
                  p.mb-0.mt-2 Asegúrate de revisar tu bandeja de spam o correo no deseado. Si aún no recibes el código puedes reenviarlo o cambiar tu correo volviendo al paso anterior.

            .text-center.my-3.pb-4(v-if="showHelp")
              b-button(
                :disabled="!resendEnabled"
                @click="resendCode"
              )
                span(v-if="resendEnabled && !loadingSendingCode") Reenviar código
                span(v-else-if="loadingSendingCode")
                  b-spinner(small variant="primary" style="margin-right: 8px;")
                  | Enviando...
                span(v-else) Código enviado

            .divider.d-flex.justify-content-between.mt-4
              b-button(@click='prevStep' variant='primary') Atrás
              //- b-button(type='submit' :variant="isFormValid ? 'secondary' : 'primary'" :disabled="!isFormValid") {{ 'Siguiente' }}
              b-button(
                type='submit'
                :variant="isFormValid ? 'secondary' : 'primary'"
                :disabled="!isFormValid || loading"
              )
                span(v-if="!loading") Siguiente
                b-spinner(v-else small variant="light" style="margin-right: 8px;")
                span(v-if="loading") Validando...

        // Paso 3: Contraseña
        div(v-if='step === 3 && !registrationSuccess')
          form(@submit.prevent='submitForm')
            b-form-input.email(
              name="username"
              type="email"
              style="display: none;"
              autocomplete="email"
              v-model='form.email'
            )
            .title.pl-0.ml-0.pl-4.pr-4 Contraseña
            b-form-group
              .input-group.pl-4.pr-4
                b-form-input.password-input(
                  :type="showPassword ? 'text' : 'password'"
                  v-model='form.password'
                  maxlength='50'
                  required
                  autocomplete="new-password"
                  @input="value => form.password = cleanWhitespace(value)"
                )
                .input-group-append
                  b-button(
                    @click='showPassword = !showPassword'
                    variant='primary'
                    type='button'
                    style="border-radius: 0 0.25rem 0.25rem 0; display: flex;"
                    :tabindex="-1"
                  )
                    i.material-icons {{ showPassword ? 'visibility_off' : 'visibility' }}

                .form-text.text-muted.mt-1(style="width: 100%;")
                  .text-danger(v-if="form.password.length < 8") La contraseña debe tener al menos 8 caracteres
                  .text-success(v-if="form.password.length >= 8 && !/\s/.test(form.password)") Contraseña válida

            .title.pl-0.ml-0.pt-3.pl-4.pr-4 Confirmar contraseña
            b-form-group
              .input-group.pl-4.pr-4
                b-form-input.password-input(
                  :type="showConfirmPassword ? 'text' : 'password'"
                  v-model='form.confirmPassword'
                  maxlength='50'
                  required
                  autocomplete="new-password"
                  @input="value => form.confirmPassword = cleanWhitespace(value)"
                )
                .input-group-append
                  b-button(
                    @click='showConfirmPassword = !showConfirmPassword'
                    variant='primary'
                    type='button'
                    style="border-radius: 0 0.25rem 0.25rem 0; display: flex;"
                  )
                    i.material-icons {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}

                .form-text.text-muted.mt-1(style="width: 100%;")
                  .text-danger(v-if="form.password !== form.confirmPassword && form.confirmPassword.length > 0") Debe coincidir con la contraseña
                  .text-success(v-if="form.password === form.confirmPassword && form.confirmPassword.length > 0") Contraseña confirmada

            .text-center
              span.text-danger(v-if="formErrors") {{ formErrors }}

            div.text-muted.d-flex.align-items-center.pl-4.pr-4
              b-checkbox(v-model="termsAndConditions")
              div
                span Declaro haber leído y estar de acuerdo con los
                | 
                a(href="/terminos-y-condiciones.pdf" target="_blank" style="color:  var(--light-secondary);") Términos y Condiciones
            .divider.d-flex.justify-content-end.mt-3.pt-3
              //- b-button(@click='prevStep' variant='primary') Atrás
              b-button(
              type='submit'
              :variant="isFormValid && termsAndConditions ? 'secondary' : 'primary'"
              :disabled="!isFormValid || loading || !termsAndConditions"
              )
                span(v-if="!loading") Registrar
                b-spinner(v-else small variant="light" style="margin-right: 8px;")
                span(v-if="loading") Registrando...

        // Paso 4: Confirmación
        div(v-if='registrationSuccess')
          .text-center.my-5
            h4.text-primary Tu registro ha sido exitoso 🎉
            p.text-primary.mt-3 Ya eres parte de <strong>Envíos Now</strong>
            //- p.text-primary.mt-2 Ahora serás redirigido a tu página de inicio
            //- p.text-primary.mt-1 {{ countdown }}
            b-button(
              style="margin-top: 1rem;"
              @click="handleLogin"
            ) Ir al inicio ahora
            b-button(
              v-if="errorOnLogin"
              @click="$router.push({ name: 'Login' })"
              style="margin-top: 1rem;"
            ) Ir al inicio de sesión

</template>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import phoneNumberFormatter from '../../shared/phoneNumberFormatter'
import { mapActions } from 'vuex/dist/vuex.common.js'
import MakeToastMixin from '../mixins/MakeToastMixin'

export default {
  mixins: [MakeToastMixin],
  data () {
    return {
      termsAndConditions: false,
      step: 1,
      showPassword: false,
      showConfirmPassword: false,
      showHelp: false,
      resendEnabled: true,
      countdown: 0,
      resendCooldown: 30, // segundos
      registrationSuccess: false,
      isEmailAvailable: null,
      checkingEmail: false,
      emailTimeout: null,
      codeError: null,
      formErrors: null,
      loading: false,
      errorOnLogin: false,
      loadingSendingCode: false,
      form: {
        name: '',
        lastName: '',
        email: '',
        phone: '',
        storeName: '',
        commune: '',
        streetName: '',
        streetNumber: '',
        apartment: '',
        storeInstagram: '',
        code: '',
        password: '',
        confirmPassword: '',
        region: 'RM'
      },
      communeOptions: [
        { value: null, text: 'Selecciona tu comuna', disabled: true },
        { value: 'Buin', text: 'Buin' },
        { value: 'Calera de Tango', text: 'Calera de Tango' },
        { value: 'Cerrillos', text: 'Cerrillos' },
        { value: 'Cerro Navia', text: 'Cerro Navia' },
        { value: 'Colina', text: 'Colina' },
        { value: 'Conchalí', text: 'Conchalí' },
        { value: 'El Bosque', text: 'El Bosque' },
        { value: 'El Monte', text: 'El Monte' },
        { value: 'Estación Central', text: 'Estación Central' },
        { value: 'Huechuraba', text: 'Huechuraba' },
        { value: 'Independencia', text: 'Independencia' },
        { value: 'Isla de Maipo', text: 'Isla de Maipo' },
        { value: 'La Cisterna', text: 'La Cisterna' },
        { value: 'La Florida', text: 'La Florida' },
        { value: 'La Granja', text: 'La Granja' },
        { value: 'La Pintana', text: 'La Pintana' },
        { value: 'La Reina', text: 'La Reina' },
        { value: 'Lampa', text: 'Lampa' },
        { value: 'Las Condes', text: 'Las Condes' },
        { value: 'Lo Barnechea', text: 'Lo Barnechea' },
        { value: 'Lo Espejo', text: 'Lo Espejo' },
        { value: 'Lo Prado', text: 'Lo Prado' },
        { value: 'Macul', text: 'Macul' },
        { value: 'Maipú', text: 'Maipú' },
        { value: 'Padre Hurtado', text: 'Padre Hurtado' },
        { value: 'Pedro Aguirre Cerda', text: 'Pedro Aguirre Cerda' },
        { value: 'Peñaflor', text: 'Peñaflor' },
        { value: 'Peñalolén', text: 'Peñalolén' },
        { value: 'Pirque', text: 'Pirque' },
        { value: 'Providencia', text: 'Providencia' },
        { value: 'Pudahuel', text: 'Pudahuel' },
        { value: 'Puente Alto', text: 'Puente Alto' },
        { value: 'Quilicura', text: 'Quilicura' },
        { value: 'Quinta Normal', text: 'Quinta Normal' },
        { value: 'Recoleta', text: 'Recoleta' },
        { value: 'Renca', text: 'Renca' },
        { value: 'San Bernardo', text: 'San Bernardo' },
        { value: 'San Joaquín', text: 'San Joaquín' },
        { value: 'San Miguel', text: 'San Miguel' },
        { value: 'San Ramón', text: 'San Ramón' },
        { value: 'Santiago', text: 'Santiago' },
        { value: 'Talagante', text: 'Talagante' },
        { value: 'Vitacura', text: 'Vitacura' },
        { value: 'Ñuñoa', text: 'Ñuñoa' }
      ]
    }
  },
  validations () {
    return {
      password: {
        required,
        minLength: minLength(6)
      },
      repeatPassword: {
        sameAsPassword: sameAs(() => this.form.password)
      }
    }
  },
  computed: {
    progress () {
      return (this.step / 3) * 100
    },
    errorMessage () {
      return this.codeError || this.formErrors
    },
    isFormValid () {
      if (this.step === 1) {
        return (
          this.form.name && this.form.email && this.isEmailAvailable && this.form.phone && this.form.storeName && this.form.streetName && this.form.streetNumber && this.form.commune && this.form.storeInstagram
        )
      } else if (this.step === 2) {
        return (/^[0-9]{6}$/.test(this.form.code) && this.isEmailAvailable)
      } else if (this.step === 3) {
        const { password, confirmPassword } = this.form

        // Validaciones individuales
        const hasMinLength = password.length >= 8
        const noWhitespace = !/\s/.test(password) && !/\s/.test(confirmPassword)
        const passwordsMatch = password === confirmPassword

        return hasMinLength && noWhitespace && passwordsMatch
      }
      return false
    }
  },
  methods: {
    ...mapActions(['login', 'checkEmailAvailability', 'sendVerificationCode', 'verifyEmail', 'createStoreAndUser']),
    phoneNumberFormatter,
    async nextStep () {
      if (this.step === 1) {
        if (!this.form.email || !this.isValidEmail(this.form.email)) {
          // mensaje de email inválido
          return
        }
        if (this.isEmailAvailable === false) {
          alert('El correo ya está en uso. Por favor, elige otro.')
          return
        }
        if (this.isEmailAvailable) {
          this.loading = true
          const codeSent = await this.sendVerificationCode({ email: this.form.email, name: this.form.name })
          if (codeSent && codeSent.status === 200) {
            console.log('código enviado')
            this.makeSuccessToast('Código enviado exitosamente', 'Éxito')
          } else {
            this.makeDangerToast(codeSent.data.error || 'Ocurrió un error al enviar el código', 'Error al enviar el código')
          }
        }
      }

      // console.log('this.form', this.form)
      if (this.step === 2 && (!/^[0-9]{6}$/.test(this.form.code))) {
        alert('El código debe tener exactamente 6 dígitos.')
        return
      }

      if (this.step === 2 && this.isEmailAvailable) {
        const codeVerified = await this.verifyEmail({ email: this.form.email, code: this.form.code })
        // console.log(codeVerified)

        if (codeVerified.status === 200) {
          // Código verificado exitosamente
          this.step++
        } else {
          this.codeError = codeVerified.data.error
          return
        }
      }

      if (this.step < 3) {
        this.loading = false
        this.step++
      }
    },
    prevStep () {
      if (this.step > 1) {
        this.step--
      }
    },
    async submitForm () {
      this.formErrors = null
      this.errorOnLogin = false
      this.loading = true
      // console.log('Datos del usuario:', this.form)
      const response = await this.createStoreAndUser({ data: this.form })

      if (response && response.status === 201) {
        // alert('Usuario registrado')
        this.registrationSuccess = true
        this.loading = false

        // this.countdown = 5

        // const interval = setInterval(() => {
        //   this.countdown--
        //   if (this.countdown <= 0) {
        //     this.resendEnabled = true
        //     clearInterval(interval)
        //   }
        // }, 1000)

        // Redirige a home después de 10 segundos
        // setTimeout(async () => {
        //   const response = await this.login({ email: this.form.email, password: this.form.password })
        //   if (!response) {
        //     this.makeDangerToast(response || 'Se produjo un error al iniciar sesión')
        //     this.errorOnLogin = true
        //   } else {
        //     this.$router.push({ name: 'Login' })
        //   }
        // }, 5000)
      } else {
        this.loading = false
        this.formErrors = response.data.error
      }
    },
    async pasteCodeFromClipboard () {
      try {
        const text = await navigator.clipboard.readText()
        const numericText = text.replace(/[^0-9]/g, '').slice(0, 6)
        this.form.code = numericText
      } catch (err) {
        alert('No se pudo acceder al portapapeles')
      }
    },
    async resendCode () {
      this.loadingSendingCode = true
      if (!this.resendEnabled) return

      if (this.isEmailAvailable) {
        const codeSent = await this.sendVerificationCode({ email: this.form.email, name: this.form.name })
        if (codeSent && codeSent.status === 200) {
          console.log(codeSent)
        } else {
          console.error('Error al reenviar el código:', codeSent)
          this.codeError = codeSent.data.error
        }
      }
      this.loadingSendingCode = false
      this.form.code = ''
      console.log('Reenviando código a:', this.form.email)

      this.resendEnabled = false
      this.countdown = this.resendCooldown

      const interval = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.resendEnabled = true
          clearInterval(interval)
        }
      }, 1000)
    },
    cleanWhitespace (value) {
      return value.replace(/\s+/g, '')
    },
    cleanInput (value) {
      return value.trim().replace(/\s+/g, ' ')
    },
    async handleCheckEmail () {
      if (!this.form.email) {
        return
      }
      if (this.isEmailAvailable) {
        return
      }

      const email = this.form.email
      // Valida formato primero
      if (!this.isValidEmail(email)) {
        this.isEmailAvailable = null
        return
      }

      this.checkingEmail = true

      try {
        const response = await this.checkEmailAvailability({ email })

        this.isEmailAvailable = response.data.isAvailable // true si no existe
        this.checkingEmail = false
        // console.log(response, 'respuesta check email')
      } catch (error) {
        this.isEmailAvailable = null
        this.checkingEmail = false
      }
    },
    isValidEmail (email) {
      // simple regex para validar formato de email
      const re = /^[^\s@]+@[^\s@]+\.[^\s@.]{2,}$/
      return re.test(email)
    },
    async handleChangeEmail () {
      const email = this.form.email
      this.form.email = this.cleanWhitespace(email.toLowerCase())

      // Valida formato primero
      if (this.isValidEmail(this.form.email)) {
        this.handleCheckEmail()
      } else {
        // console.log('llamando allá')
      }
    },
    debouncedCheckEmail () {
      this.isEmailAvailable = null
      this.form.email = this.cleanWhitespace(this.form.email.toLowerCase())
      // Cancela el timeout anterior si existe
      if (this.emailTimeout) {
        clearTimeout(this.emailTimeout)
      }

      // Programa la ejecución después de 600ms
      this.emailTimeout = setTimeout(() => {
        if (this.isValidEmail(this.form.email)) {
          this.handleCheckEmail()
        } else {
          // console.log('llamando allá')
        }
      }, 600) // 600ms = 0.6 segundos sin escribir
    },
    maskEmail (email) {
      if (!email || !email.includes('@')) return ''

      const [local, domain] = email.split('@')

      // Si tiene 1 letra: solo un caracter visible + *
      if (local.length <= 1) {
        return '*'.repeat(2) + '@' + domain
      }

      // Si tiene 2 letras: una visible + *
      if (local.length === 2) {
        return local[0] + '*' + '@' + domain
      }

      // Si tiene 3 letras: dos visibles + *
      if (local.length === 3) {
        return local.slice(0, 2) + '*' + '@' + domain
      }

      // Si tiene 4 o más: 3 visibles + tantos * como sean necesarios
      const visibleChars = 3
      const maskedLength = Math.max(local.length - visibleChars, 3) // mínimo 3 asteriscos
      const displayed = local.slice(0, visibleChars) + '*'.repeat(maskedLength)

      return `${displayed}@${domain}`
    },
    async handleLogin () {
      const response = await this.login({ email: this.form.email, password: this.form.password })
      if (!response) {
        this.makeDangerToast(response || 'Se produjo un error al iniciar sesión')
        this.errorOnLogin = true
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
    ensureAtSymbolOnFocus () {
      if (!this.form.storeInstagram.startsWith('@')) {
        this.form.storeInstagram = '@' + this.form.storeInstagram
      }
    },
    handleInstagramInput (value) {
      this.ensureAtSymbolOnFocus()
      // Si el valor está vacío o es solo @, aseguramos @
      if (!value || value === '@') {
        this.form.storeInstagram = ''
        return
      }

      // Aseguramos que empiece con @
      if (!value.startsWith('@')) {
        value = '@' + value.replace(/@/g, '') // Evita múltiples @
      }

      // Extraemos solo el nombre de usuario (sin el @)
      const usernamePart = value.slice(1)

      // Limpiamos espacios y caracteres no permitidos
      const cleaned = this.cleanWhitespace(usernamePart)
      const valid = cleaned
        .toLowerCase()
        .replace(/[^a-z0-9_.]/g, '') // Solo caracteres permitidos
        .replace(/\.{2,}/g, '.') // No múltiples puntos seguidos
        .replace(/^\.+|\.+$/g, '') // No . al inicio ni final
        .replace(/^_+|_+$/g, '') // No _ al inicio ni final

      // Reconstruimos con @ al inicio
      const finalValue = '@' + valid

      // Actualizamos el modelo
      this.form.storeInstagram = finalValue
      if (finalValue === '@') {
        this.form.storeInstagram = ''
        return ''
      } else {
        return finalValue
      }
    }

  },
  mounted () {
    this.form.code = ''
  },
  watch: {
    async step (value) {
      if (value) {
        console.log('código reseteado')
        this.form.code = ''
        this.showHelp = false
      }
    },
    'form.code': {
      handler (value) {
        this.codeError = null
        if (value.toString().length === 6 && this.isEmailAvailable) {
          this.nextStep()
        }
      },
      immediate: true,
      deep: true
    },
    'form.password': {
      handler (value) {
        this.form.password = this.cleanWhitespace(value)
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang='scss' scoped>
@import '../../../src/styles/colors.scss';
#Register{
  margin: auto;
  max-width: 420px;
  min-width: 40vw;
  font-size: 15px;
  color: $card-bg;
  .group {
    width: 100%;
  }
  .botones {
    margin-top:40px;
    display: flex;
    flex-direction: column;
  }
  .recover {
    color: var(--light-secondary);
  }
  .register {
    color: var(--light-secondary);
    margin-top: 15px;
  }
  hr{
    background: $card-bg;
    margin-top: -10px;
  }
  .icon{
    padding: 0px;
    margin-top: 16px;
    font-size: 30px;
  }
  .title{
    color: #939393 !important;
    /* margin-left:12px; */
    font-weight: bold;
    font-size: 13px;
  }
  .input {
    &::placeholder {
      color: #adacac !important;
    }
  }
}
.password-input {
  &::-webkit-text-security {
    display: none;
  }

  &::-ms-reveal {
    display: none;
  }
}

.card-body {
  .icon {
    color: #3EF7DE;
  }
}
</style>
